import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from './firebase'

/**
 * AI_CHAT is client-side only — the cheap tier for conversational Send when
 * the current turn is a Discuss (not Build). The backend `reservePremiumAction`
 * callable does not accept AI_CHAT; it is charged through the same
 * `walletService.reserveCredits` path as build turns but at a much lower
 * hold amount so low-credit users can still hold a conversation.
 */
export const PREMIUM_ACTION_COSTS = { AI_CHAT: 2, SIMPLE_EDIT: 10, GENERATION: 25, ADVANCED_GENERATION: 50, FORM_EXPORT: 5, REPORT_EXPORT: 5, EXTERNAL_SYNC: 2, TOUR_GENERATION: 15 } as const
export type PremiumAction = keyof typeof PREMIUM_ACTION_COSTS

export const reservePremiumAction = async (workspaceId: string, action: PremiumAction, options: { quantity?: number; targetId?: string } = {}) => {
  const callable = httpsCallable<{ workspaceId: string; action: PremiumAction; quantity?: number; targetId?: string }, { reservationId: string; creditsCharged: number }>(firebaseFunctions, 'reservePremiumAction')
  return (await callable({ workspaceId, action, ...options })).data
}
